module.exports = ($scope, $state, project, workflowSteps, adverseTermsLists) ->
  project.id = undefined
  project.related_project = $state.params.projectId
  project.related_project_type = 'delta_cloned'
  $scope.adverseTermsLists = adverseTermsLists
  $scope.setProject(project)

  for workflowStep in workflowSteps
    workflowStep.from_date = project.created_date.split('T')[0]

  $scope.setWorkflows(workflowSteps)
  $scope.isDeltaProject = true
